import { createClient } from '@supabase/supabase-js'
import { environment } from './environment'
import { GIFT_CARDS_TENANT_ID, RECHARGES_TENANT_ID, SHOP_TENANT_ID } from './environment'

export const supabaseClient = createClient(environment.SUPABASE_URL, environment.ANON_KEY)
